import ServiceContainer from 'services/service-container';
import { apiClient } from 'services/api-client';
import { axiosClient, postConfigAxiosClient } from 'services/api-client/client';
import { configurePlatformClient } from '@cloudquery/api-platform-multi-tenant';
import { cloudQueryPlatformFetcher } from 'services/cloudquery-platform-client';
import omit from 'lodash/omit';

export const initializeStores = () => {
  const serviceContainer = new ServiceContainer(apiClient);
  postConfigAxiosClient(axiosClient, serviceContainer);

  configurePlatformClient({
    fetcher: cloudQueryPlatformFetcher({
      axiosInstance: axiosClient,
      getOrganizationId: () => serviceContainer.organizationsStore.currentOrganizationId
    })
  });

  return omit(serviceContainer, 'apiClient') as Omit<ServiceContainer, 'apiClient'>;
};
